/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:21:20
 * @LastEditTime: 2019-08-26 15:34:20
 * @LastEditors: Please set LastEditors
 */
import common from './common';

const routes = [
    ...common
];

export default [...routes];
